import * as React from "react";
import { WizardCruisePWAProps, WizardCruisePWAFTNodeOptions } from "./typings";
import { inject, observer } from "mobx-react";
import { normalizeOptionsData } from "src/stores/FlexTemplateStore";
import { WizardCruisePWAView } from "./WizardCruisePWAView";
import { WizardCruisePWA3PPView } from "./WizardCruisePWA3PPView";

@inject("wizardState", "flexModuleModelStore")
@observer
export class WizardCruisePWA extends React.Component<WizardCruisePWAProps> {
  constructor(props: WizardCruisePWAProps) {
    super(props);

    const cruiseWizardState = this.props.wizardState.cruiseWizardState;
    const { flexTemplateNode, flexModuleModelStore } = props;
    const model = flexModuleModelStore.getModel(flexTemplateNode.id);
    const options = normalizeOptionsData(flexTemplateNode, model) as WizardCruisePWAFTNodeOptions;
    cruiseWizardState.overrideConfig(() => {
      cruiseWizardState.config.elementId = flexTemplateNode.id;
      cruiseWizardState.config.heading.fixedTitle = options.fixedLobTitle;
      cruiseWizardState.config.heading.lobSubtitleBreakPoint =
        options.lobSubtitleBreakPoint || cruiseWizardState.config.heading.lobSubtitleBreakPoint;
      cruiseWizardState.config.heading.hideLobTitle = options.hideLobTitle;
    });
    cruiseWizardState.updateDateFromConfig();
  }

  public render() {
    if (this.props.wizardState.cruiseWizardState.config.displayWizard3pp) {
      return <WizardCruisePWA3PPView {...this.props} />;
    }

    return <WizardCruisePWAView {...this.props} />;
  }
}

export default WizardCruisePWA;
